import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion';


function Footer() {
  return (
    <>
<section className="relative w-full overflow-hidden h-[400px] lg:h-[600px] bg-black">
  {/* Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/assets/value/footer.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Fallback Image (in case video doesn’t load) */}
  {/* <img
    src="/assets/value/footer-bg.jpg"
    alt="Cable Management & Termination Solutions"
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
  /> */}

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/40 z-10"></div>

  {/* Content */}
  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center w-full p-4 text-center z-20">
    <motion.h6
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="font-[500] font-kanit lg:text-[55px] text-[30px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-white lg:pb-[40px] pb-[20px]"
    >
      Your One-Stop Technical Partner in
      <br /> Cable Management & Termination Solutions
    </motion.h6>

    <Link to="/contact-us">
      <button
        className="flex items-center justify-center cursor-pointer gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-white py-[14px] px-[20px] border border-white bg-transparent hover:bg-black rounded-full group transition-all duration-300"
      >
        Let’s Connect
        <img
          src="/assets/nav/arrow.svg"
          alt="Trusted cable management and termination solutions provider in the UAE"
          className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150"
        />
      </button>
    </Link>
  </div>
</section>



      <div className="lg:pt-[50px] pt-[60px]" style={{ background: `radial-gradient(76.95% 235.97% at 30% 98%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 34%), radial-gradient(71.83% 220.26% at 64% 100%, rgba(228, 74, 26, 0.15) 0%, rgba(228, 74, 26, 0) 34%)` }}>
<div className="w-full max-w-[1440px] mx-auto lg:px-[50px] px-[20px] lg:pb-[50px] pb-[30px]">

  <div className="flex flex-col lg:flex-row items-start justify-between gap-[40px]">

    {/* Logo & Social Section */}
    <div className="max-w-[350px] w-full">
      <Link to="/">
        <img
          src="/assets/nav/logo.svg"
          className="h-[90px]"
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
      </Link>
      <p className="max-w-[318px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pt-[18px] pb-[23px]">
        Your Trusted Partner in Cable Management & Termination Solutions
      </p>
      <div className="flex gap-[10px]">
        <Link to=""><img src="/assets/footer/facebook.svg" alt="facebook" /></Link>
        <Link to=""><img src="/assets/footer/linkedin.svg" alt="linkedin" /></Link>
        <Link to=""><img src="/assets/footer/skype.svg" alt="skype" /></Link>
        <Link to=""><img src="/assets/footer/instagram.svg" alt="instagram" /></Link>
      </div>
    </div>

    {/* Get in Touch Section */}
    <div className="max-w-[350px] w-full">
      <h6 className="font-[500] font-inter text-[22px] leading-[33px] tracking-[0.3px] text-[#0E2A62] pb-[16px]">
        Get in touch
      </h6>
      <div className="pb-[12px]">
        <p className="font-[500] font-kanit text-[16px] leading-[24px] text-[#0E2A62]">Location</p>
        <p className="font-[300] font-kanit text-[17px] leading-[22px] text-[#49577A]">
          P O BOX 513347, Ind Area 18 <br />Sharjah, UAE
        </p>
      </div>
      <div className="pb-[12px]">
        <p className="font-[500] font-kanit text-[16px] leading-[24px] text-[#0E2A62]">Email</p>
        <a href="mailto:info@saig.me" className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">
          info@saig.me
        </a>
      </div>
      <div>
        <p className="font-[500] font-kanit text-[17px] leading-[27px] text-[#0E2A62]">For more information</p>
        <h6 className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">
          +971 6 555 6624 <br /> +971 52 898 8788
        </h6>
      </div>
    </div>

    {/* Quick Links Section */}
    <div className="max-w-[300px] w-full lg:ml-[40px]">
      <h6 className="font-[500] font-inter text-[22px] leading-[33px] tracking-[0.3px] text-[#0E2A62] pb-[16px]">
        Quick link
      </h6>
      <ul className="flex flex-col gap-[12px]">
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/">Home</Link></li>
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/about">About Us</Link></li>
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/blog">Blog</Link></li>
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/contact-us">Contact</Link></li>
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/terms-condition">Terms & Conditions</Link></li>
        <li className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]"><Link to="/privacy-policy">Privacy Policy</Link></li>
      </ul>
    </div>

    {/* Certification Logos Section */}
    <div className="max-w-[150px] w-full">
      <h6 className="font-[500] font-inter text-[22px] leading-[33px] tracking-[0.3px] text-[#0E2A62] pb-[16px]">
        Certifications
      </h6>
      <div className="flex flex-col gap-[12px] items-start">
        <img src="/assets/footer/certify logo (3).png" className="w-[65px] h-auto" alt="Certify Logo 3" />
        <img src="/assets/footer/certify logo (1).png" className="w-[65px] h-auto" alt="Certify Logo 1" />
        <img src="/assets/footer/certify logo (2).png" className="w-[65px] h-auto" alt="Certify Logo 2" />
        <img src="/assets/footer/certify logo (4).png" className="w-[65px] h-auto" alt="Certify Logo 4" />
      </div>
    </div>

  </div>
</div>



   <div className="max-w-[1290px] mx-auto w-full pt-[23px] pb-[20px] border-t border-[#74738680] flex flex-col md:flex-row items-center justify-between gap-4">
  <p className="font-[300] font-kanit text-[17px] leading-[27px] text-[#0E2A62] text-center md:text-left">
    © Al Ibtekar All rights Reserved. Designed & Developed by{" "}
    <Link className="underline" to="https://strixdigital.in/">
      Strix Digital
    </Link>
  </p>
 {/* <div className="flex gap-[20px] justify-center md:justify-end items-center">
  <img
    src="/assets/footer/certify logo (3).png"
    className="h-[40px] sm:h-[45px] md:h-[50px] w-auto"
    alt="Certify Logo 3"
  />
  <img
    src="/assets/footer/certify logo (1).png"
    className="h-[40px] sm:h-[45px] md:h-[50px] w-auto"
    alt="Certify Logo 1"
  />
  <img
    src="/assets/footer/certify logo (2).png"
    className="h-[40px] sm:h-[45px] md:h-[50px] w-auto"
    alt="Certify Logo 2"
  />
  <img
    src="/assets/footer/certify logo (4).png"
    className="h-[35px] sm:h-[38px] md:h-[40px] w-auto"
    alt="Certify Logo 4"
  />
</div> */}

</div>

      </div>
    </>
  )
}

export default Footer